module.exports = __webpack_public_path__ + "static/media/everyday_digital_weekend_papers_may_2024.c0a69f3a.png";